export const buildQueryURL = (queryParams) => {
  let params = new URLSearchParams(queryParams);
  return params.toString();
};

export const buildFilterQuery = (filterOpts) => {
  return filterOpts.reduce((filterQueryValue, currentFilterOption) => {
    const currentFilterValue = `${currentFilterOption.option}${currentFilterOption.operator}${currentFilterOption.value}`;
    if (filterQueryValue === "") return currentFilterValue;
    return `${filterQueryValue};${currentFilterValue}`;
  }, "");
};
